module.exports = __webpack_public_path__ + "img/inreport.296e8e25.svg";